/** Wall-clock countdown helpers for the SVS flow.
 * The microdeposit countdown must target an absolute instant (effectiveExpiresAt, epoch millis)
 * computed service-side as the earlier of the token and session TTL caps. Deriving the remaining
 * time from the wall clock on every tick — rather than decrementing a counter once per second —
 * keeps the timer accurate even when the browser throttles or freezes background-tab timers, and
 * lets it resume correctly after the tab is closed and reopened.
*/

// Fallback flow window (seconds) used only when the backend has not supplied an effectiveExpiresAt.
export const FLOW_WINDOW_SECONDS = 600;

/**
 * Remaining milliseconds until the given absolute expiry instant, clamped at zero.
 * Returns null when no expiry instant is provided.
 * @param {number|null|undefined} effectiveExpiresAt epoch millis the flow expires
 * @returns {number|null} remaining milliseconds, or null if no target
 */
export function resolveRemainingMs(effectiveExpiresAt) {
  if (effectiveExpiresAt == null) {
    return null;
  }
  return Math.max(0, effectiveExpiresAt - Date.now());
}

/**
 * Remaining whole seconds until the given absolute expiry instant, clamped at zero.
 * Returns null when no expiry instant is provided.
 * @param {number|null|undefined} effectiveExpiresAt epoch millis the flow expires
 * @returns {number|null} remaining seconds, or null if no target
 */
export function resolveRemainingSeconds(effectiveExpiresAt) {
  const remainingMs = resolveRemainingMs(effectiveExpiresAt);
  if (remainingMs == null) {
    return null;
  }
  return Math.ceil(remainingMs / 1000);
}
